import type { GameState } from "@/game/types";
import { LANDMARKS } from "@/game/data";
import { cn } from "@/lib/utils";

export function TrailMap({ state }: { state: GameState }) {
  const pct = Math.min(100, (state.distance / state.totalDistance) * 100);
  const nextLandmark = LANDMARKS[state.currentLandmarkIndex + 1];
  const milesToNext = nextLandmark
    ? Math.max(0, Math.round(nextLandmark.distance - state.distance))
    : 0;

  return (
    <div className="space-y-3">
      <div className="flex items-end justify-between font-terminal text-lg">
        <span>{Math.round(state.distance)} mi traveled</span>
        <span className="text-muted-foreground">
          {nextLandmark
            ? `${milesToNext} mi to ${nextLandmark.name}`
            : "Freedom City ahead"}
        </span>
      </div>

      {/* The trail */}
      <div className="relative h-10 rounded-full border-2 border-primary/40 bg-secondary/60">
        <div
          className="absolute inset-y-0 left-0 rounded-full bg-primary/25 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
        {/* Landmark ticks */}
        {LANDMARKS.map((lm, i) => {
          const lp = (lm.distance / state.totalDistance) * 100;
          const reached = state.distance >= lm.distance;
          return (
            <div
              key={lm.name}
              className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2"
              style={{ left: `${lp}%` }}
              title={lm.name}
            >
              <div
                className={cn(
                  "size-3 rounded-full border-2",
                  reached
                    ? "border-primary bg-primary"
                    : "border-muted-foreground/50 bg-background",
                  i === LANDMARKS.length - 1 && "size-4",
                )}
              />
            </div>
          );
        })}
        {/* Wagon */}
        <div
          className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 text-2xl transition-all duration-500"
          style={{ left: `${pct}%` }}
          aria-hidden
        >
          🛒
        </div>
      </div>
    </div>
  );
}
